var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransferIconDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_947",
    "data-name": "Group 947",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 18.333,
    viewBox: "0 0 20 18.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 20,
    height: 18.333,
    fill: "#00000026"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M0,52.07c.209-.384.454-.529.765-.453s.477.319.487.766a4.381,4.381,0,0,0,3.863,4.184,5.389,5.389,0,0,0,.564.033q2.89,0,5.779,0h.211c0-.09,0-.16,0-.23,0-.794,0-1.588,0-2.382a.634.634,0,0,1,.376-.665.653.653,0,0,1,.759.189q2.2,2.108,4.4,4.208a.654.654,0,0,1,0,1.1q-2.2,2.1-4.406,4.207a.691.691,0,0,1-.553.239.611.611,0,0,1-.574-.645c0-.814,0-1.627,0-2.441,0-.071,0-.142,0-.247h-.237c-1.725,0-3.45.018-5.174-.009A6.44,6.44,0,0,1,.112,54.654c-.042-.235-.075-.472-.112-.708V52.07",
    transform: "translate(0 -44.935)",
    fill: "#00000026"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M36.829,11.2c-.005,0-.013.006-.016.011-.179.359-.428.511-.731.446-.325-.069-.5-.319-.505-.732A4.373,4.373,0,0,0,31.306,6.67c-2-.017-4,0-5.994,0-.044,0-.088.006-.153.011,0,.078,0,.148,0,.218,0,.794,0,1.588,0,2.382a.633.633,0,0,1-.377.664.654.654,0,0,1-.759-.19q-2.2-2.109-4.4-4.208a.651.651,0,0,1,0-1.1q2.21-2.11,4.42-4.22A.662.662,0,0,1,24.6,0a.614.614,0,0,1,.555.662c0,.807,0,1.614,0,2.421,0,.071,0,.142,0,.248h.257c1.718,0,3.437-.017,5.154.009a6.436,6.436,0,0,1,6.146,5.269c.041.236.075.473.112.709Z",
    transform: "translate(-16.829 0.001)",
    fill: "#00000026"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIconDisabled);
export default __webpack_public_path__ + "static/media/transfer-icon-disabled.1e75ff357e5b810d571be32ea0d44c04.svg";
export { ForwardRef as ReactComponent };